export default __webpack_public_path__ + "static/media/start-1.ef572cd1.png";